/* eslint-disable eqeqeq */
import { Field, useFormikContext } from "formik";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { isEmpty, get } from "lodash";
import {
  DatePicker,
  FieldDropSide,
  SearchableList,
  CsplTable as Table,
} from "../../../components";
import { usDateFormat } from "../../../utils";
import company from "../../../mocks/company.json";
import CensusEmployeeAgeMaster from "../../../mocks/CensusEmployeeAgeMaster.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { getEmployeeRehireDetails } from "../../../services";
import {
  useRouterParams,
  useRequest,
  useComponentDidUpdate,
} from "../../../abstracts";
import { getEmploymentStatusList } from "../../../services";
import { isDate } from "moment";
import { RehireDetails } from "./RehireDetails";
import moment from "moment";

const columns = [
  {
    label: "Hire / rehire date",
    className: "column-rehireDate",
    columnName: "reHireDate",
  },
  {
    label: "Term date",
    className: "column-termDate",
    columnName: "terminationDate",
  },
];

const EmploymentAgeDetail = (props) => {
  const [isAdd, setIsAdd] = useState(false);
  const toggle = () => {
    setIsAdd(!isAdd);
  };
  const [show, setShow] = useState(false);
  const [showStatus, setshowStatus] = useState(false);

  const {
    fields,
    values,
    setFieldValue,
    isEdit,
    isSave,
    isStartDate,
    isEndDate,
  } = props;
  const { censusId } = useRouterParams();
  //const intcensusId = parseInt(censusId, 10);
  const { setErrors, errors, validateForm } = useFormikContext();

  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };

  const calculateAge = (birthDate) => {
    var a = moment();
    var b = moment(new Date(birthDate), "MM-YYYY");
    var age = moment.duration(a.diff(b));
    return age.years() <= 1 && age.months() <= 1
      ? age.years() + " year " + age.months() + " month"
      : age.years() <= 1
      ? age.years() + " year " + age.months() + " months"
      : age.months() <= 1
      ? age.years() + " years " + age.months() + " month"
      : age.years() + " years " + age.months() + " months";
  };

  // const { loading: IsLoading, response: rehireDetails } = useRequest({
  //   method: getEmployeeRehireDetails,
  //   payload: censusId,
  //   defaultResponse: [],
  // });

  const rehireDetails = get(values, "rehireDetails", []);
  const setStatusWarning = () => {
    setshowStatus(true);
  };

  // useComponentDidUpdate(setStatusWarning, [values[fields.employmentStatusId]]);
  const handleClose = () => {
    setShow(false);
  };
  const handleClose1 = () => {
    setshowStatus(false);
  };
  const [deleteIndex, setDeleteIndex] = useState(0);
  const addRow = (index) => {
    const newRehire = {
      id: 0,
      employeeRehireId: null,
      reHireDate: null,
      rehireInd: true,
      terminationDate: null,
    };
    values["rehireDetails"].splice(index, 0, newRehire);
    for (let i = index; i < values["rehireDetails"].length; i++) {
      errors[`${i + 1}-0`] = errors[`${i}-0`];
      errors[`${i + 1}-1`] = errors[`${i}-1`];
    }
    setFieldValue("rehireDetails", values["rehireDetails"]);
    delete errors[`${index}-0`];
    delete errors[`${index}-1`];
    setErrors(errors);
  };

  const assignStatus = (term, rehire) => {
    var activeStatus = employmentStatusList?.find(
      (x) => x.employmentStatus === 1
    );
    var terminatedStatus = employmentStatusList?.find(
      (x) => x.employmentStatus === 2
    );
    var retiredStatus = employmentStatusList?.find(
      (x) => x.employmentStatus === 3
    );
    var deceasedStatus = employmentStatusList?.find(
      (x) => x.employmentStatus === 6
    );
    var disabledStatus = employmentStatusList?.find(
      (x) => x.employmentStatus === 8
    );
    if (rehire > term) {
      if (
        values[fields.employmentStatusId] === terminatedStatus?.id ||
        values[fields.employmentStatusId] === retiredStatus?.id ||
        values[fields.employmentStatusId] === deceasedStatus?.id ||
        values[fields.employmentStatusId] === disabledStatus?.id
      ) {
        setStatusWarning();
        setFieldValue(
          fields.employmentStatus,
          activeStatus?.employmentStatusName
        );
        setFieldValue(fields.employmentStatusId, activeStatus?.id);
      }
    } else {
      if (
        values[fields.employmentStatusId] !== terminatedStatus?.id &&
        values[fields.employmentStatusId] !== retiredStatus?.id &&
        values[fields.employmentStatusId] !== deceasedStatus?.id &&
        values[fields.employmentStatusId] !== disabledStatus?.id
      ) {
        setStatusWarning();
        setFieldValue(
          fields.employmentStatus,
          terminatedStatus?.employmentStatusName
        );
        setFieldValue(fields.employmentStatusId, terminatedStatus?.id);
      }
    }
  };
  const setDates = (columnName, value) => {
    if (!values["rehireDetails"]) {
      const a = [
        {
          id: 0,
          employeeRehireId: null,
          reHireDate: value,
          rehireInd: true,
          terminationDate: null,
        },
      ];
      setFieldValue("rehireDetails", a);
      reassignRehireDates(a);
    } else {
      var d = values["rehireDetails"].map((a, b) => {
        switch (columnName) {
          case "hireDate":
            if (b == 0)
              return {
                ...a,
                reHireDate: value,
              };
            return a;
          case "reHireDate":
            if (b == values["rehireDetails"].length - 1 && b !== 0) {
              return {
                ...a,
                reHireDate: value,
              };
            }
            return a;
          case "terminationDate":
            if (b == values["rehireDetails"].length - 1) {
              return {
                ...a,
                terminationDate: value,
              };
            }
            return a;
          default:
            return a;
        }
      });
      setFieldValue("rehireDetails", d);
      reassignRehireDates(d);
    }
  };
  const reassignRehireDates = (newValues) => {
    var term = newValues?.findLastIndex((x) => x.terminationDate != null);
    var rehire = newValues?.findLastIndex((x) => x.reHireDate != null);
    if (rehire == 0) setFieldValue(fields.reHireDate, null);
    else setFieldValue(fields.reHireDate, newValues[rehire]?.reHireDate);
    setFieldValue(fields.terminationDate, newValues[term]?.terminationDate);
    assignStatus(term, rehire);
  };

  const deleteRow = (d) => {
    let newValues = values["rehireDetails"].filter((x, i) => i != d);
    setShow(false);
    setFieldValue("rehireDetails", newValues);
    reassignRehireDates(newValues);
    delete errors[`${d}-0`];
    delete errors[`${d}-1`];
    for (let i = d; i < values["rehireDetails"].length; i++) {
      errors[`${i}-0`] = errors[`${i + 1}-0`];
      errors[`${i}-1`] = errors[`${i + 1}-1`];
    }
    setErrors(errors);
  };

  const { response: employmentStatusList } = useRequest({
    method: getEmploymentStatusList,
    payload: get(values, "companyId", 0),
    defaultResponse: [],
  });

  const masterEmploymentStatusId = employmentStatusList.find(
    ({ id }) => id === values[fields.employmentStatusId]
  )
    ? employmentStatusList.find(
        ({ id }) => id === values[fields.employmentStatusId]
      ).employmentStatus
    : 0;

  return (
    <div>
      <p className="mt-20 plan-sub-heading">Dates</p>
      <div className="d-flex">
        <Field
          isRequired
          label="Date of Birth"
          size="md"
          name={fields.birthDate}
          value={usDateFormat(values[fields.birthDate])}
          isDatePicker
          onClear={() => onDaySelected(fields.birthDate, null)}
          popupContent={
            <DatePicker
              onDayClick={(value) => onDaySelected(fields.birthDate, value)}
              value={usDateFormat(values[fields.birthDate])}
            />
          }
          component={FieldDropSide}
          disabled={isEdit && !isSave}
        />
        {values.birthDate === undefined ||
        values.birthDate === null ||
        values.birthDate > new Date() ? (
          ""
        ) : (
          <div
            className="plan-sub-heading mt-20 ml-4"
            style={{ alignSelf: "flex-end" }}
          >
            {calculateAge(values.birthDate)}
          </div>
        )}
      </div>
      <Field
        isRequired
        label="Hire Date"
        size="md"
        name={fields.hireDate}
        value={usDateFormat(values[fields.hireDate])}
        isDatePicker
        onClear={() => {
          onDaySelected(fields.hireDate, null);
          setDates("hireDate", null);
        }}
        popupContent={
          <DatePicker
            onDayClick={(value) => {
              onDaySelected(fields.hireDate, value);
              setDates("hireDate", value);
            }}
            value={usDateFormat(values[fields.hireDate])}
          />
        }
        component={FieldDropSide}
        disabled={isEdit && !isSave}
      />
      <Field
        size="md"
        isRequired
        name={fields.employmentStatus}
        value={values[fields.employmentStatus]}
        options={
          employmentStatusList &&
          employmentStatusList.map((status, index) => ({
            label: status.employmentStatusName,
            value: status.id,
          }))
        }
        label="Employment Status"
        popupContent={
          <SearchableList
            label="Select Employment Status"
            options={
              employmentStatusList &&
              employmentStatusList.map((status, index) => ({
                label: status.employmentStatusName,
                value: status.id,
              }))
            }
            onSelect={(value) => {
              setFieldValue(
                fields.employmentStatus,
                employmentStatusList.find((x) => x.id === value)
                  .employmentStatusName
              );
              setFieldValue(fields.employmentStatusId, value);
              let _ = employmentStatusList.find(({ id }) => id === value);
              if (!isStartDate && ![4, 5, 9].includes(_.employmentStatus)) {
                setFieldValue(fields.leaveStartDate, null);
              }
              if (!isEndDate && ![4, 5, 9].includes(_.employmentStatus)) {
                setFieldValue(fields.leaveEndDate, null);
              }
            }}
            selectedValue={values[fields.employmentStatusId]}
            value={values[fields.employmentStatusId]}
          />
        }
        component={FieldDropSide}
        disabled={isEdit && !isSave}
      />

      <Field
        label="Leave Start Date"
        isRequired
        size="md"
        name={fields.leaveStartDate}
        value={usDateFormat(values[fields.leaveStartDate])}
        isDatePicker
        onClear={() => onDaySelected(fields.leaveStartDate, null)}
        popupContent={
          <DatePicker
            onDayClick={(value) => onDaySelected(fields.leaveStartDate, value)}
            value={usDateFormat(values[fields.leaveStartDate])}
          />
        }
        component={FieldDropSide}
        disabled={
          (isEdit && !isSave) || ![4, 5, 9].includes(masterEmploymentStatusId)
        }
      />
      <Field
        label="Leave End Date"
        size="md"
        name={fields.leaveEndDate}
        value={usDateFormat(values[fields.leaveEndDate])}
        isDatePicker
        onClear={() => onDaySelected(fields.leaveEndDate, null)}
        popupContent={
          <DatePicker
            onDayClick={(value) => onDaySelected(fields.leaveEndDate, value)}
            value={usDateFormat(values[fields.leaveEndDate])}
          />
        }
        component={FieldDropSide}
        disabled={
          (isEdit && !isSave) || ![4, 5, 9].includes(masterEmploymentStatusId)
        }
      />

      <Field
        label="Most Recent Term Date"
        isRequired
        size="md"
        name={fields.terminationDate}
        value={usDateFormat(values[fields.terminationDate])}
        isDatePicker
        onClear={() => {
          onDaySelected(fields.terminationDate, null);
          setDates("terminationDate", null);
        }}
        popupContent={
          <DatePicker
            onDayClick={(value) => {
              onDaySelected(fields.terminationDate, value);
              setDates("terminationDate", value);
            }}
            value={usDateFormat(values[fields.terminationDate])}
          />
        }
        component={FieldDropSide}
        disabled={masterEmploymentStatusId === 1 ? true : isEdit && !isSave}
      />
      <Field
        label="Most Recent Rehire Date"
        isRequired
        size="md"
        name={fields.reHireDate}
        value={usDateFormat(values[fields.reHireDate])}
        isDatePicker
        onClear={() => {
          onDaySelected(fields.reHireDate, null);
          // values["rehireDetails"].length==2&&values["rehireDetails"][1]?.terminationDate==null&&deleteRow(1)
          setDates("reHireDate", null);
        }}
        popupContent={
          <DatePicker
            onDayClick={(value) => {
              onDaySelected(fields.reHireDate, value);
              values["rehireDetails"].length == 1 && addRow(1);
              setDates("reHireDate", value);
            }}
            value={usDateFormat(values[fields.reHireDate])}
          />
        }
        component={FieldDropSide}
        disabled={isEdit && !isSave}
      />
      {isEdit == true || censusId != undefined || values["rehireDetails"] ? (
        <p className="link-text font-weight-500" onClick={toggle}>
          {isAdd === false ? "View Rehire Details" : "Hide Rehire Details"}
        </p>
      ) : null}
      {isAdd === true ? (
        <RehireDetails
          isEdit={isEdit}
          isSave={isSave}
          rehireDetails={rehireDetails}
          setFields={setFieldValue}
          fields1={fields}
          values1={values}
          setShow={setShow}
          setDeleteIndex={setDeleteIndex}
          addRow={addRow}
          reassignRehireDates={reassignRehireDates}
        />
      ) : null}
      <Modal show={showStatus} onHide={handleClose1}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose1}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              <p>
                {
                  "The Employment Status has been updated based on the changes made"
                }
              </p>
              <br />
              <Button className="cancel-btn" onClick={handleClose1}>
                Ok
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              <h4>Are you sure?</h4>
              <p>
                You are attempting to delete the Rehire History. Do you wish to
                continue ?
              </p>
              <Button
                className="remove-btn mr-4"
                onClick={() => deleteRow(deleteIndex)}
              >
                Yes
              </Button>
              <Button className="cancel-btn" onClick={handleClose}>
                No
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EmploymentAgeDetail;
